import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

// import * as ol from 'openlayers';
// // import * as ol from 'openlayers/dist/ol-debug';
import { ScaleLine, defaults as defaultControls, Control } from 'ol/control';
import Feature from 'ol/Feature';
import WKT from 'ol/format/WKT';
// import Point from 'ol/geom/Point';
// import LineString from 'ol/geom/LineString';
import {
	LineString,
	MultiLineString,
	MultiPoint,
	MultiPolygon,
	Point,
	Polygon,
} from 'ol/geom';
import Select from 'ol/interaction/Select';
import { Fill, RegularShape, Stroke, Style, Text, Icon, Circle } from 'ol/style';
import { StyleLike } from 'ol/style/Style';
import { transform as transformProjection } from 'ol/proj';
import Modify from 'ol/interaction/Modify';

import layerswitcher from 'ol-layerswitcher';


import { LRSMap } from './../../assets/TS/LRSMap_New';
import { colors, styleAttrs } from 'assets/TS/StyleConfig';
import { AttrIndexService } from './attr-index.service';
import { AppinfoService } from './appinfo.service';
import { UserService } from './user.service';

export interface CommonMapConfig {
	layersConfig?: LayersConfigByName;
	windowView?: {name: string, type: string, url: string}; // TODO
	cursorUrl?: string;
	minReso?: number;
	resolution?: number;
	center?: number[];
	onMapMoveend?: Function;
	onPointermove?: Function;
}
export interface LayersConfigByName {
	[name: string]: {
		style?: StyleLike;
		minResolution?: number;
		maxResolution?: number;
	};
}
export interface CommonStyleConfig {
	imgFillColor?: string;
	pointRadius?: number;
	label?: {
		offsetY: number;
		scale: number;
	};
	strokeColor?: string;
	strokeWidth?: number;
	lineDash?: number[];
	fillColor?: string;
}

export interface VectorTileGridInfoByLevel {
	[level: number]: VectorTileGridInfo;
}
export interface VectorTileGridInfo {
	numTiles: number;
	tileHeight: number;
	tileWidth: number;
}

export type GeometryType = 'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon' | 'GeometryCollection' | 'Circle';

@Injectable()
export class CommonMapService {

	public defaultMapConfig: CommonMapConfig = {
		cursorUrl: './assets/css/img/map-loc_blue_36x36_36x36-32.png',
	};
	public center = [-12476020.61, 3954973.93]; // Phoenix
	// Label column to display labels on map
	public labelCol = 'labelCol';

	public zoomToLayerMinReso = 2;

	public mapUtility = new LRSMap.Utilities();

	mapProj = 'EPSG:3857';

	constructor(
		@Inject(DOCUMENT) private document: any,
		private appinfoService: AppinfoService,
		private attrIndexService: AttrIndexService,
		private userService: UserService
	) {
		// if (this.appinfoService.customerProfile.centroidLatlong) {
		// 	this.center = transformProjection(this.appinfoService.customerProfile.centroidLatlong, 'EPSG:4326', this.mapProj);
		// }
		if (this.userService.customerInfo.cusCentroid) {
			const centroidRaw = this.userService.customerInfo.cusCentroid.split(' ');
			const centroidLatlong = [Number(centroidRaw[1]), Number(centroidRaw[0])];
			this.center = transformProjection(centroidLatlong, 'EPSG:4326', this.mapProj);
		}
	}
	init(target: string, config?: CommonMapConfig): LRSMap.Map {
		config = config || {};
		const cursorUrl = config.cursorUrl || this.defaultMapConfig.cursorUrl;
		// Init map
		const map = new LRSMap.Map(target, {
			control: 
				// defaultControls({
				// 	attribution: false,
				// 	zoomOptions: {
				// 		zoomInLabel: '',
				// 		zoomOutLabel: ''
				// 	}
				// }).extend(
					[
						// new layerswitcher({}),
						new ScaleLine({
							units: 'metric',
							target: 'map-scaleline'
						})
						// new ScaleLine({
						// 	units: 'metric',
						// 	bar: true,
						// 	steps: 2,
						// 	minWidth: 40,
						// })
					],
				// ),
			center: config.center || this.center,
			viewMinResolution: config.minReso,
			resolution: config.resolution
		}, {
			cursorUrl: cursorUrl,
			onMapMoveend: config.onMapMoveend,
			onPointermove: config.onPointermove
		});
		// // Change ol.control default styles
		// this.setOlControlStyles(target);

		// Config Projection Definitions
		map.setProjDef(
			'EPSG:32123',
			'+proj=lcc +lat_1=40.03333333333333 +lat_2=38.73333333333333 +lat_0=38 +lon_0=-82.5 ' +
			'+x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
		);
		// Add base map
		map.setBaseMapsLayerGroup([
			// new LRSMap.BaseMap('ArcGIS Cache', 'NAIP', true, null, 'https://azgeo.az.gov/arcgis/rest/services/imagery/NAIP2017/MapServer'),
			new LRSMap.BaseMap('Open Street Map', 'Open Street Map', false),
			new LRSMap.BaseMap('ArcGIS Cache', 'World Imagery', false, null, 'https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer'),
			new LRSMap.BaseMap('ArcGIS Cache', 'World Street', true, null, 'https://server.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer'),
			new LRSMap.BaseMap('ArcGIS Cache', 'World Light', false, null, 'https://server.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Base/MapServer')
		]);
		if (config.layersConfig) {
			for (const name of Object.keys(config.layersConfig)) {
				map.addLayer(name, config.layersConfig[name]);
			}
		}

		// Change layerSwitcher icon
		setTimeout(() => {
			const button = this.document.querySelector('.layer-switcher button');
			if (button) {
				button.classList.add('glyphicons');
				button.classList.add('glyphicons-map');
			}
		});
		return map;
	}
	// // Add select interaction - clicking on map
	// public addSelectInteraction(map: LRSMap.Map, onSelectCallback?: Function, layers?: any[] | Function, selectFilter?: Function, toggleCondition?: Function, style?) {
	// 	style = style || this.defaultHighlightStyle;
	// 	const selectSingleClick = new Select({
	// 		style: style,
	// 		layers: layers,
	// 		toggleCondition: toggleCondition,
	// 		filter: selectFilter
	// 	});
	// 	if (onSelectCallback) {
	// 		selectSingleClick.on('select', (e) => {
	// 			onSelectCallback(e, selectSingleClick);
	// 		});
	// 	}
	// 	map.olMap.addInteraction(selectSingleClick);
	// 	map.interactions.selectSingleClick = selectSingleClick;
	// 	return selectSingleClick;
	// }
	defaultHighlightStyle(feat) {
		const color = colors.highlight;
		const style = new Style ({
			image: new Circle({
				radius: 10,
				fill: new Fill({
					color: color
				})
			}),
			stroke: new Stroke({
				width: 10,
				color: color
			}),
			zIndex: 2
		});
		const styles = [style];
		// add border
		const borderStyle = new Style ({
			stroke: new Stroke({
				width: 13,
				color: 'rgba(255, 255, 0, 0.5)'
			}),
			zIndex: 2
		});
		styles.unshift(borderStyle);
		return styles;
	}
	public addModifyInteraction(map: LRSMap.Map, modifyLayerName, insertVertexCondition?) {
		const config: any = {
			source: map.addedLayers[modifyLayerName].getSource(),
			// insertVertexCondition: condition.never,
		}
		if (insertVertexCondition) {
			config.insertVertexCondition = insertVertexCondition;
		}
		const modify = new Modify(config);
		map.olMap.addInteraction(modify);
		map.interactions.modify = modify;
		return modify;
	}

	// Draw a feature on data layer using an array of wkt
	// Parameter options.labelArr: an array of label, draw a text style for each feature if provided
	drawDataByWkt(map: LRSMap.Map, attributeArray: {wkt: string; id?; props?;}[], layer?, options?: {skipZoomToLayer?: boolean; skipClearLayer?: boolean; labelArr?: string[]}) {
		options = options || {};
		attributeArray = attributeArray || [];
		const features = [];
		for (let i = 0; i < attributeArray.length; i++) {
			const a = attributeArray[i];
			if (!a.wkt) { return; }
			const feature = this.createFeatureByWkt(a.wkt);
			if (a.id || a.id === 0) {
				feature.setId(a.id);
			}
			if (a.props) {
				feature.setProperties(a.props);
			}
			if (options.labelArr) {
				const prop: any = {};
				prop[this.labelCol] = options.labelArr[i];
				feature.setProperties(prop);
			}
			features.push(feature);
		}
		layer = layer || map.addedLayers.dataLayer;
		if (!options.skipClearLayer) {
			layer.getSource().clear();
		}
		layer.getSource().addFeatures(features);
		if (!options.skipZoomToLayer) {
			map.zoomToLayer(layer, {
				minReso: this.zoomToLayerMinReso
			});
		}
		return features;
	}
	// Clear map layer data
	clearMap(map: LRSMap.Map, layers: any[], skipResetView?: boolean) {
		layers.forEach((l) => {
			if (l) {
				l.getSource().clear();				
			}
		});
		if (!skipResetView) {
			map.olMap.getView().setCenter(this.center);
			map.olMap.getView().setResolution(100);
		}
	}

	// Create feature from wkt
	createFeatureByWkt(wkt: string): Feature {
		const wktFormat = new WKT;
		const feature = wktFormat.readFeature(wkt);
		return feature;
	}

	getCommonStyle(config?: CommonStyleConfig) {
		config = config || {};
		const imgFillColor = config.imgFillColor || colors.mapFill;
		return new Style({
			image: new RegularShape({
				fill: new Fill({
					color: imgFillColor
				}),
				points: 20,
				radius: config.pointRadius || 4,
			}),
			stroke: new Stroke({
				color: config.strokeColor || colors.mapFill,
				width: config.strokeWidth || 3,
				lineDash: config.lineDash
			}),
			fill: new Fill({
				color: config.fillColor || 'rgba(0, 0, 255, 0.1)'
			})
		});
	}
	// Parameter column: which column is used to get the label text
	getLabelStyle(feature, column?: string, config?: CommonStyleConfig) {
		config = config || {};
		column = column || this.labelCol;
		let labelText = feature.getProperties()[column] || '';
		labelText = labelText.toString();
		if (labelText.replace(/\s/g, '').length === 0) {
			labelText = 'N/A';
		}
		return new Style({
			text: new Text({
				offsetY: config.label ? config.label.offsetY : -18,
				text: labelText,
				font: 'Open Sans',
				scale: config.label ? config.label.scale : 1.3,
				fill: new Fill({
					color: colors.mapLabel
				})
			})
		});
	}

	// Change ol.control default style
	private setOlControlStyles(containerId) {
		const zoomInBtn = this.document.querySelector('#' + containerId + ' button.ol-zoom-in');
		const zoomOutBtn = this.document.querySelector('#' + containerId + ' button.ol-zoom-out');
		zoomInBtn.className += ' glyphicons glyphicons-zoom-in';
		zoomOutBtn.className += ' glyphicons glyphicons-zoom-out';
	}

	setCursorLocation(coord: number[], layer: any) {
		if (!coord || (typeof(coord[0]) !== 'number' || Number.isNaN(coord[0])) || (typeof(coord[1]) !== 'number' || Number.isNaN(coord[1]))) {
			console.log('coordinate not valid');
			layer.getSource().clear();
			return;
		}
		let feat = layer.getSource().getFeatures()[0];
		if (!feat) {
			feat = new Feature({
				geometry: new Point(coord)
			});
			layer.getSource().addFeature(feat);
		} else {
			feat.setGeometry(new Point(coord));
		}
	}


	public async toggleTooltipOnPointermove(e, tooltipElem, tooltipLayer, getTooltipContent: (feat: Feature) => any) {
		if (!tooltipElem) {
			return;
		}
		// Check if mouse over feature
		const hit = e.map.forEachFeatureAtPixel(e.pixel, (f, layer) => {
			if (layer === tooltipLayer) {
				// Set tooltip
				const content = getTooltipContent(f);
				tooltipElem.style.display = '';
				tooltipElem.innerHTML = content;
				// Position
				this.setTooltipPosition(tooltipElem, e.map.getTarget(), e.pixel);
				return true;
			}
		});
		// Change cursor shape if mouse over feature
		if (hit) {
			e.map.getViewport().style.cursor = 'pointer';
		} else {
			e.map.getViewport().style.cursor = '';
			tooltipElem.style.display = 'none';
		}
	}
	public setTooltipPosition(elem, mapId, mapPixel, offset?: number) {
		const map = this.document.getElementById(mapId);
		const body = this.document.getElementsByTagName('body')[0];
		if (elem && map && body) {
			const rect = map.getBoundingClientRect();
			let tooltipPositionV: 't' | 'b'; // top or bottom
			let tooltipPositionH: 'l' | 'r'; // left or right
			if (mapPixel[0] < rect.width / 2) {
				tooltipPositionH = 'r'
			} else {
				tooltipPositionH = 'l';
			}
			if (mapPixel[1] < rect.height / 2) {
				tooltipPositionV = 'b'
			} else {
				tooltipPositionV = 't';
			}
			const v = mapPixel[1] + rect.top;
			const h = mapPixel[0] + rect.left;
			if (!offset && offset !== 0) {
				offset = 20;
			}
			let top, left;
			if (tooltipPositionV === 'b') {
				top = v + offset;
				if (body.offsetHeight - top < elem.offsetHeight) {
					top = body.offsetHeight - elem.offsetHeight;
				}
			} else {
				top = v - elem.offsetHeight - offset;
				if (top < 0) {
					top = 0;
				}
			}
			elem.style.top = top + 'px';
			if (tooltipPositionH === 'l') {
				left = h - elem.offsetWidth - offset;
			} else {
				left = h + offset;
			}
			elem.style.left = left + 'px';
		}
	}

	public transformExtent(ext: number[], toPrj, fromPrj?: string) {
		fromPrj = fromPrj || this.mapProj;
		const min = transformProjection([ext[0],ext[1]], fromPrj, toPrj);
		const max = transformProjection([ext[2],ext[3]], fromPrj, toPrj); 
		return min.concat(max);
	}

// VectorTile
	public calcGridLevel(numGridLevel: number, gridsInfo: VectorTileGridInfoByLevel, mapExtent: number[], toPrj: string) {
		const transformedMapExtent = this.transformExtent(mapExtent, toPrj);
		const mapWidth = transformedMapExtent[2] - transformedMapExtent[0];
		const mapHeight = transformedMapExtent[3] - transformedMapExtent[1];
		let i;
		for (i = 0; i < numGridLevel; i++) {
			if (mapWidth >= gridsInfo[i].tileWidth * 0.8 || mapHeight >= gridsInfo[i].tileHeight * 0.8) {
				break;
			}
		}
		const gridLevel = i >= numGridLevel ? numGridLevel - 1 : i;
		return gridLevel;		
	}
	public calcVectorTileRangeByExtent(gridInfo: VectorTileGridInfo, mapExtent: number[], vtExtent: number[], vtSrid: string) {	
		const transformedMapExtent = this.transformExtent(mapExtent, vtSrid);
		let columnNumStart = Math.ceil((transformedMapExtent[0] - vtExtent[0]) / gridInfo.tileWidth) - 1;
		let columnNumEnd = Math.ceil((transformedMapExtent[2] - vtExtent[0]) / gridInfo.tileWidth) - 1;
		let rowNumStart = Math.ceil((vtExtent[3] - transformedMapExtent[3]) / gridInfo.tileHeight) - 1;
		let rowNumEnd = Math.ceil((vtExtent[3] - transformedMapExtent[1]) / gridInfo.tileHeight) - 1;		

		columnNumStart = this.refineTileNum(columnNumStart, gridInfo.numTiles);
		columnNumEnd = this.refineTileNum(columnNumEnd, gridInfo.numTiles);
		rowNumStart = this.refineTileNum(rowNumStart, gridInfo.numTiles);
		rowNumEnd = this.refineTileNum(rowNumEnd, gridInfo.numTiles);
		return {
			rowNumStart: rowNumStart,
			rowNumEnd: rowNumEnd,
			columnNumStart: columnNumStart,
			columnNumEnd: columnNumEnd
		}
	}
	public refineTileNum(num: number, numTilesInGrid: number) { // to prevent the requested tile number exceed tile grid.
		if (num < 0) {
			return 0;
		} else if (num > numTilesInGrid - 1) {
			return numTilesInGrid - 1;
		}
		return num;
	}
}
